import {css} from "@emotion/css";

export const styles = {
  modalWrap: css`
    padding: 0;
  `,
  body: css`
    width: 100%;
    max-width: 100%;
    height: 100%;

    border-radius: 0;
    box-shadow: none;

    overflow-y: scroll;

    padding-bottom: 48px;

    header svg {
      width: 20px;
      height: 20px;
    }
  `,
};
